export default __webpack_public_path__ + "static/media/minus.667d541f.svg";